import React from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";

export default function CTASection() {
  return (
    <section className="max-w-7xl mx-auto px-6 lg:px-8 py-24">
      <div className="glass rounded-3xl p-10 lg:p-16 relative overflow-hidden" data-reveal>
        <div className="absolute -top-20 -right-20 h-80 w-80 brand-gradient opacity-30 blur-3xl rounded-full animate-drift" />
        <div className="absolute -bottom-20 -left-20 h-80 w-80 bg-violet-500 opacity-20 blur-3xl rounded-full animate-drift-slow" />
        <div className="relative">
          <h2 className="font-heading text-3xl sm:text-4xl lg:text-5xl font-black tracking-tight max-w-2xl">
            Replace your agency tonight. <span className="shimmer-text">Save lakhs every month.</span>
          </h2>
          <p className="mt-5 text-white/60 max-w-xl">
            5-minute onboarding. AI handles everything from there. Start with the Starter plan, free for 14 days.
          </p>
          <Link
            to="/register"
            data-testid="cta-final-register"
            className="mt-8 inline-flex items-center gap-2 brand-gradient gradient-animate px-6 py-3.5 rounded-lg font-semibold glow-orange hover:opacity-90"
          >
            Launch my AI agency <ArrowUpRight className="h-4 w-4" />
          </Link>
        </div>
      </div>
    </section>
  );
}
